/* eslint-disable no-unused-vars */
import { connect } from 'react-redux';
/* eslint-disable no-unused-vars */
import i18next from 'i18next';
import QueryString from 'query-string';
import React from 'react';
import ReactTable from 'react-table';
import { Redirect } from 'react-router-dom';
import ScrollArea from 'react-scrollbar';
import ui from 'redux-ui';

import { AccessHelper, BaseTable } from '../../helpers';
import {
  DevicesService,
  GroupingsService,
  TagsService,
  TimeFormattingService,
  DeviceStatusesService
} from '../../services';
import { RowButton } from '../RowButton';
import { ScrollModule } from '../ScrollModule';
import { SelectInput } from '../SelectInput';

@ui({
  key: 'devices-list',
  persist: true,
  state: {
    selectedStatus: null,
    selectedGrouping: null,
    selectedArea: null,
    selectedTag: null,
    prevPage: null
  }
})
@connect(state => ({
  me: state.user.me,
  currentGrouping: state.currentGrouping.currentGrouping
}))
class DeviceList extends React.Component {

  constructor(props) {
    super(props);

    const passedState = this.props.currLocation ? this.props.currLocation.state : null;

    this.DEFAULT_SORTED = [{ id: 'lastDeviceTime', desc: true }];

    this.refresh = this.refresh.bind(this);
    this.fetchData = this.fetchData.bind(this);
    this.datafetched = this.datafetched.bind(this);
    this.makeDatatableRequest = this.makeDatatableRequest.bind(this);
    this.updateRequestURL = this.updateRequestURL.bind(this);
    this.getAssignedDevices = this.getAssignedDevices.bind(this);
    this.getUnassignedDevices = this.getUnassignedDevices.bind(this);
    this.getForcePage = this.getForcePage.bind(this);
    this.doSearch = this.doSearch.bind(this);
    this.bulkEditLinkClick = this.bulkEditLinkClick.bind(this);
    this.updateSelectedStatus = this.updateSelectedStatus.bind(this);
    this.updateSelectedGrouping = this.updateSelectedGrouping.bind(this);
    this.updateSelectedArea = this.updateSelectedArea.bind(this);
    this.updateSelectedTag = this.updateSelectedTag.bind(this);

    const parsedOptions = QueryString.parse(this.props.currLocation.search);

    this.state = {
      linkTo: null,
      localErrorHandler: this.props.localErrorHandler,
      statusFilterOptions: passedState ? passedState.statusFilterOptions : null,
      groupingFilterOptions: passedState ? passedState.groupingFilterOptions : null,
      areaFilterOptions: passedState ? passedState.areaFilterOptions : null,
      tagFilterOptions: passedState ? passedState.tagFilterOptions : null,
      selectedStatus: passedState ? passedState.currentStatusFilter : null,
      selectedGrouping: passedState ? passedState.currentGroupingFilter : null,
      selectedArea: passedState ? passedState.currentAreaFilter : null,
      selectedTag: passedState ? passedState.currentTagFilter : null,
      showUnassignedGroupings: passedState ? passedState.showUnassignedGroupings : null,
      hasError: false,
      data: [],
      pageCount: null,
      forcePage: null,
      loading: true,
      totalElements: null,
      filtered: [],
      parsedOptions,
      searchValue: passedState && passedState.searchValue ? passedState.searchValue : '',
      currentHistoryCount: passedState && passedState.currentHistoryCount
        ? passedState.currentHistoryCount : 0,
      timeout: 0,
      viewAllowed: AccessHelper.userHasAccess(this.props.me.availableRoutes, '/config/devices/view/:deviceId'),
      editAllowed: AccessHelper.userHasAccess(this.props.me.availableRoutes, '/config/devices/edit/:deviceId')
    };
  }

  componentDidMount() {
    const parsedOptions = this.state.parsedOptions ? this.state.parsedOptions : {};
    if (this.state.groupingFilterOptions == null) {
      if (this.props.me.adhocRoleAssignment) {
        setTimeout(() => {
          const groupingFilterOptions = [{
            label: null,
            options: this.props.me.availableGroupings.map(grouping => ({
              fqn: grouping.fullyQualifiedName,
              label: grouping.name,
              value: `${grouping.id}`
            }))
          }];
          let selectedGrouping = null;
          if (this.state.selectedGrouping) {
            selectedGrouping = this.state.selectedGrouping;
          } else if (parsedOptions.filterByGroupingIds) {
            const found = groupingFilterOptions[0].options
              .find(grouping => grouping.value === parsedOptions.filterByGroupingIds);
            selectedGrouping = found ? found.value : null;
          }
          this.setState({
            groupingFilterOptions,
            selectedGrouping
          });
        }, 100);
      } else {
        GroupingsService.getAllWithAccess(this.props.currentGrouping.id).then((response) => {
          const groupingFilterOptions = response.groupings;
          let selectedGrouping = null;
          if (this.state.selectedGrouping) {
            selectedGrouping = this.state.selectedGrouping;
          } else if (parsedOptions.filterByGroupingIds) {
            const filteredGrouping = response.groupings.filter(group =>
              group.options.filter(grouping => grouping.value === parsedOptions.filterByGroupingIds))
              .flatMap((group) => {
                const newGroup = Object.assign({}, group);
                return newGroup.options
                  .filter(grouping => grouping.value === parsedOptions.filterByGroupingIds);
              });
            selectedGrouping = filteredGrouping[0].value;
          }
          this.setState({
            groupingFilterOptions,
            selectedGrouping
          });
        }).catch((error) => {
          console.error(error);
          this.state.localErrorHandler(error.message);
        });
      }
    }
    if (this.state.tagFilterOptions == null) {
      TagsService.listAll().then((response) => {
        let selectedArea = null;
        if (this.state.selectedArea) {
          selectedArea = this.state.selectedArea;
        } else if (parsedOptions.filterByAreaIds) {
          selectedArea = response.tags.filter(tag => tag.id.toString() === parsedOptions.filterByAreaIds)[0].id;
        }
        let selectedTag = null;
        if (this.state.selectedTag) {
          selectedTag = this.state.selectedTag;
        } else if (parsedOptions.filterByTagIds) {
          selectedTag = response.tags.filter(tag => tag.id.toString() === parsedOptions.filterByTagIds)[0].id;
        }
        this.setState({
          selectedArea,
          selectedTag,
          tagFilterOptions: this.mapTagOptions(response.tags.filter(tag => tag.tagType && tag.tagType.token !== 'area')),
          areaFilterOptions: this.mapTagOptions(response.tags.filter(tag => tag.tagType && tag.tagType.token === 'area'))
        });
      }).catch((error) => {
        console.error(error);
        this.setState({ errorMessage: i18next.t('messages.could-not-load-tags-view') });
      });
    }
    if (this.state.statusFilterOptions == null) {
      DeviceStatusesService.getAll().then((response) => {
        let selectedStatus = null;
        if (this.state.selectedStatus) {
          selectedStatus = this.state.selectedStatus;
        } else if (parsedOptions.filterByStatuses) {
          selectedStatus = response.deviceStatuses.filter(status => status.id.toString() === parsedOptions.filterByStatuses)[0].id;
        }
        this.setState({
          selectedStatus,
          statusFilterOptions: response.deviceStatuses.map(status => ({ label: status.name, value: status.id }))
        });
      }).catch((error) => {
        console.error(error);
        this.setState({ errorMessage: i18next.t('messages.could-not-load-status-view') });
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props !== prevProps && this.props.refresh) {
      this.fetchData(this.devicesTable && this.devicesTable.state ? this.devicesTable.state : null);
    }
  }

  getAssignedDevices(options, curSearch, callback) {
    this.updateOptions(options);
    DevicesService.getAll(options, true).then((response) => {
      this.props.finishedRefresh();
      if (curSearch === this.state.searchValue) {
        const pageCount = Math.ceil(response.page.totalElements / this.devicesTable.state.pageSize);
        const forcePage = this.getForcePage(pageCount);
        callback({
          data: response.devices,
          pageCount,
          forcePage,
          searchValue: curSearch,
          recordsTotal: response.page.totalElements
        });
      }
    }).catch((error) => {
      console.error(error);
      this.props.finishedRefresh();
      this.setState({ hasError: true });
      callback({ data: [], recordsTotal: 0, recordsFiltered: 0 });
      this.state.localErrorHandler(error.message);
    });
  }

  getUnassignedDevices(options, curSearch, callback) {
    delete options.filterByGroupingIds;
    this.updateOptions(options);

    DevicesService.getAllUnAssigned(options).then((response) => {
      if (curSearch === this.state.searchValue) {
        const pageCount = Math.ceil(response.page.totalElements / this.devicesTable.state.pageSize);
        const forcePage = this.getForcePage(pageCount);
        callback({
          data: response.devices,
          pageCount,
          forcePage,
          searchValue: curSearch,
          recordsTotal: response.page.totalElements
        });
      }
    }).catch((error) => {
      console.error(error);
      this.setState({ hasError: true });
      callback({ data: [], recordsTotal: 0, recordsFiltered: 0 });
      this.state.localErrorHandler(error.message);
    });
  }

  getForcePage(pageCount) {
    let forcePage = null;
    if (this.devicesTable &&
      this.devicesTable.state &&
      this.devicesTable.state.page >= pageCount && pageCount > 0) {
      forcePage = pageCount - 1;
    }
    return forcePage;
  }

  updateOptions(options) {
    if (this.state.selectedStatus) {
      if (this.state.selectedStatus.length === 0) {
        options.push({ filterByStatuses: [-1] });
      } else {
        options.push({ filterByStatuses: this.state.selectedStatus });
      }
    }
    if (this.state.selectedGrouping) {
      if (this.state.selectedGrouping.length === 0) {
        options.push({ filterByGroupingIds: [-1] });
      } else {
        options.push({ filterByGroupingIds: this.state.selectedGrouping });
      }
    }
    if (this.state.showUnassignedGroupings) {
      options.push({ showUnassignedGroupings: true });
    }
    if (this.state.selectedArea) {
      if (this.state.selectedArea.length === 0) {
        options.push({ filterByAreaIds: [-1] });
      } else {
        options.push({ filterByAreaIds: this.state.selectedArea });
      }
    }
    if (this.state.selectedTag) {
      if (this.state.selectedTag.length === 0) {
        options.push({ filterByTagIds: [-1] });
      } else {
        options.push({ filterByTagIds: this.state.selectedTag });
      }
    }
  }

  makeDatatableRequest(data, callback) {
    if (this.state.hasError) {
      return;
    }
    const apiOptions = this.state.parsedOptions;
    const options = BaseTable.buildFetchDataOptions(apiOptions, this.DEFAULT_SORTED);
    const curSearch = this.state.searchValue;

    if (this.state.showUnassignedGroupings) {
      delete apiOptions.filterByGroupingIds;
    }

    if (this.state.searchValue) {
      options.push({ search: this.state.searchValue });
    }

    if (this.state.showUnassignedGroupings) {
      this.getUnassignedDevices(options, curSearch, callback);
    } else {
      this.getAssignedDevices(options, curSearch, callback);
    }
  }

  mapTagOptions(tags) {
    return tags.sort((a, b) => {
      if (a.name.toLowerCase() > b.name.toLowerCase()) {
        return 1;
      } else if (a.name.toLowerCase() < b.name.toLowerCase()) {
        return -1;
      }
      return 0;
    }).map(tag => ({ label: tag.name, value: tag.id }));
  }

  fetchData(tableData) {
    if (this.updateRequestURL(tableData, null)) {
      return;
    }

    this.setState({
      loading: true
    });

    this.makeDatatableRequest(tableData, this.datafetched, null);
  }

  datafetched(res) {
    if (this.state.searchValue && res.search && res.search !== this.state.searchValue) {
      // not current request
      return;
    }

    this.setState({
      data: res.data,
      pageCount: res.pageCount,
      forcePage: res.forcePage,
      loading: false,
      totalElements: res.recordsTotal
    });
  }

  bulkEditLinkClick() {
    this.setState({ linkTo: '/config/devices/bulk-edit' });
  }

  refresh() {
    this.updateRequestURL(this.devicesTable &&
    this.devicesTable.state ? this.devicesTable.state : null);
  }

  updateSelectedGrouping({ value }) {
    this.setState({
      selectedGrouping: value === 'unassigned' ? null : value,
      showUnassignedGroupings: value === 'unassigned' ? true : null
    }, () => {
      this.refresh();
    });
  }

  updateSelectedStatus({ value }) {
    this.setState({
      selectedStatus: value
    }, () => {
      this.refresh();
    });
  }

  updateSelectedArea({ value }) {
    this.setState({
      selectedArea: value
    }, () => {
      this.refresh();
    });
  }

  updateSelectedTag({ value }) {
    this.setState({
      selectedTag: value
    }, () => {
      this.refresh();
    });
  }

  updateSearchValue(val) {
    this.setState({ searchValue: val }, () => {
      this.fetchData(this.devicesTable && this.devicesTable.state ? this.devicesTable.state : null);
    });
  }

  doSearch(val) {
    const value = val.target.value;
    this.setState({ searchValue: value });
    if (this.state.timeout) {
      clearTimeout(this.state.timeout);
    }
    this.state.timeout = setTimeout(() => {
      this.updateSearchValue(value);
    }, 500);
  }

  updateRequestURL(tableData, deviceLink) {
    const options = BaseTable.buildURLOptions(tableData, this.DEFAULT_SORTED);
    this.updateOptions(options);

    const params = options.map(option => Object.keys(option).map(k => `${k}=${option[k]}`)).join('&');

    const currentSearch = this.props.currLocation.search ? this.props.currLocation.search : '?';

    if (`?${params}` !== currentSearch) {
      if (this.state.currentHistoryCount > 100) {
        console.error('Exceeded the history count stack of 100.');
        return false;
      }
      this.props.pushHistory({
        search: `?${params}`,
        state: {
          currentHistoryCount: this.state.currentHistoryCount + 1,
          currentStatusFilter: this.state.selectedStatus,
          currentGroupingFilter: this.state.selectedGrouping,
          currentAreaFilter: this.state.selectedArea,
          currentTagFilter: this.state.selectedTag,
          searchValue: this.state.searchValue,
          linkTo: deviceLink,
          showUnassignedGroupings: this.state.showUnassignedGroupings
        }
      });
      return true;
    }
    return false;
  }

  renderDisplayName(data) {
    return <div title={data.row._original.serialNumber}>{ data.row.displayName }</div>;
  }

  renderNormalTime(data) {
    const timezone = data.original.deviceGrouping &&
    data.original.deviceGrouping.timezone ? data.original.deviceGrouping.timezone : null;
    const date = TimeFormattingService.renderDate(data.value, timezone);
    const time = TimeFormattingService.renderTime(data.value, timezone);
    return (<span>{ date }<br />{ time }</span>);
  }

  renderAreas(data) {
    const tags = data.original.tags ? data.original.tags.filter(tag => tag.tagType && tag.tagType.token === 'area') : null;
    if (tags) {
      return (
        <div className="selected-tags">
          {tags.map(tag =>
            (
              <div className="selected-tag" key={tag.id}>
                <span className="selected-tag-text">{tag.name}</span>
              </div>
            )
          )}
        </div>
      );
    }
    return '';
  }

  renderTags(data) {
    const tags = data.original.tags ? data.original.tags.filter(tag => tag.tagType && tag.tagType.token !== 'area') : null;
    if (tags) {
      return (
        <div className="selected-tags">
          {tags.map(tag =>
            (
              <div className="selected-tag" key={tag.id}>
                <span className="selected-tag-text">{tag.name}</span>
              </div>
            )
          )}
        </div>
      );
    }
    return '';
  }

  render() {
    const {
      data,
      pageCount,
      loading,
      totalElements,
      statusFilterOptions,
      groupingFilterOptions,
      areaFilterOptions,
      tagFilterOptions,
      showUnassignedGroupings,
      selectedStatus,
      selectedGrouping,
      selectedArea,
      selectedTag
    } = this.state;

    if (this.state.linkTo) {
      return (<Redirect
        push
        to={{
          pathname: this.state.linkTo,
          state: {
            backLinkSearch: this.props.currLocation.search,
            searchValue: this.state.searchValue
          }
        }}
      />);
    }

    const dynamicOptions = BaseTable.buildDynamicOptions(
      this.state.parsedOptions,
      this.state.forcePage,
      this.DEFAULT_SORTED);

    if (groupingFilterOptions && tagFilterOptions && areaFilterOptions && statusFilterOptions) {
      return (
        <div className="device-list">
          <ScrollModule />
          <ScrollArea
            speed={0.8}
            className="scroll-container"
            contentClassName="scrollable-content"
            horizontal
          >
            <div className="react-table-custom">
              <ReactTable
                getTheadFilterThProps={(state, rowInfo, column) => ({
                  style: {
                    overflow: 'visible'
                  }
                })}
                className="-striped -highlight"
                ref={(el) => { this.devicesTable = el; }}
                manual
                data={data}
                pages={pageCount} // Display the total number of pages
                loading={loading} // Display the loading overlay when we need it
                onFetchData={this.fetchData} // Request new data when things change
                totalElements={totalElements}
                showPaginationTop
                style={{ paginationTop: { width: '200px' } }}
                customButtons={[{ label: 'Bulk Edit', method: this.bulkEditLinkClick, link: '/config/devices/bulk-edit' }]}
                defaultSorted={[{
                  id: 'displayName',
                  desc: true // not necessary unless set to true, but it's good to know its there.
                }]}
                columns={[
                  {
                    Header: i18next.t('table-headers.device-name'),
                    id: 'displayName',
                    accessor: 'displayName',
                    Cell: cell => this.renderDisplayName(cell),
                    sortable: true,
                    minResizeWidth: 50,
                    filterable: true,
                    Filter: <div className="filter">
                      <i className="table-search-icon" />
                      <input
                        style={{ width: '100%', margin: '0 auto' }}
                        value={this.state.searchValue}
                        onChange={this.doSearch}
                        type="text"
                        name="search"
                        className="table-search-box"
                        autoComplete="off"
                      />
                    </div>
                  },
                  {
                    Header: i18next.t('table-headers.device-status'),
                    accessor: 'deviceStatus',
                    Cell: cell =>
                      <span>{ cell.value.name }</span>,
                    sortable: false,
                    minResizeWidth: 50,
                    filterable: true,
                    Filter: () => (
                      <div className="filter select-filter">
                        <SelectInput
                          name="area"
                          input={{
                            value: statusFilterOptions.find(option => option.value === selectedStatus),
                            onChange: this.updateSelectedStatus
                          }}
                          options={[
                            { label: i18next.t('show-all'), value: '' }
                          ].concat(statusFilterOptions)}
                          isSearchable
                          meta={{}}
                          placeholder={i18next.t('show-all')}
                        />
                      </div>
                    )
                  },
                  {
                    Header: i18next.t('table-headers.group'),
                    id: 'deviceGrouping',
                    accessor: 'deviceGrouping.name',
                    Cell: cell =>
                      <span>{ cell.value ? cell.value : i18next.t('pages.device-configuration.unassigned') }</span>,
                    sortable: false,
                    minResizeWidth: 50,
                    filterable: true,
                    Filter: () => (
                      <div className="filter select-filter">
                        <SelectInput
                          name="deviceGrouping"
                          input={{
                            value: showUnassignedGroupings ? { label: 'Unassigned', value: 'unassigned' } : groupingFilterOptions.flatMap(optionCat => optionCat.options).find(option => option.value === selectedGrouping) || null,
                            onChange: this.updateSelectedGrouping
                          }}
                          options={[
                            { label: i18next.t('show-all'), value: '' },
                            { label: i18next.t('unassigned'), value: 'unassigned' }
                          ].concat(groupingFilterOptions)}
                          isSearchable
                          meta={{}}
                          filterGroupHeading
                          placeholder={i18next.t('show-all')}
                        />
                      </div>
                    )
                  },
                  {
                    Header: i18next.t('table-headers.area'),
                    accessor: 'deviceArea',
                    Cell: row => (this.renderAreas(row)),
                    sortable: false,
                    minResizeWidth: 50,
                    filterable: true,
                    Filter: () => (
                      <div className="filter select-filter">
                        <SelectInput
                          name="area"
                          input={{
                            value: areaFilterOptions.find(option => option.value === selectedArea),
                            onChange: this.updateSelectedArea
                          }}
                          options={[
                            { label: i18next.t('show-all'), value: '' }
                          ].concat(areaFilterOptions)}
                          isSearchable
                          meta={{}}
                          placeholder={i18next.t('show-all')}
                        />
                      </div>
                    )
                  },
                  {
                    Header: i18next.t('table-headers.tags'),
                    id: 'deviceTag',
                    accessor: 'tags',
                    Cell: row => (this.renderTags(row)),
                    sortable: false,
                    minResizeWidth: 50,
                    filterable: true,
                    Filter: () => (
                      <div className="filter select-filter">
                        <SelectInput
                          name="tags"
                          input={{
                            value: tagFilterOptions.find(option => option.value === selectedTag),
                            onChange: this.updateSelectedTag
                          }}
                          options={[
                            { label: i18next.t('show-all'), value: '' }
                          ].concat(tagFilterOptions)}
                          isSearchable
                          meta={{}}
                          placeholder={i18next.t('show-all')}
                        />
                      </div>
                    )
                  },
                  {
                    Header: i18next.t('table-headers.last-read'),
                    id: 'lastUpdatedAt',
                    accessor: 'lastUpdatedAt',
                    Cell: cell => this.renderNormalTime(cell),
                    sortable: true,
                    width: 140,
                    minResizeWidth: 50
                  },
                  {
                    Cell: cell => (<RowButton
                      allowView={this.state.viewAllowed}
                      allowEdit={this.state.editAllowed}
                      viewPath={{
                        pathname: `/config/devices/view/${cell.original.id}`,
                        state: {
                          backLinkSearch: this.props.currLocation.search,
                          searchValue: this.state.searchValue
                        }
                      }}
                      editPath={{
                        pathname: `/config/devices/edit/${cell.original.id}`,
                        state: {
                          backLinkSearch: this.props.currLocation.search,
                          searchValue: this.state.searchValue
                        }
                      }}
                    />),
                    sortable: false,
                    minResizeWidth: 50,
                    width: 150
                  }
                ]}
                {...dynamicOptions}
              />
            </div>

          </ScrollArea>

        </div>
      );
    }
    return (
      <div className="loader">{ i18next.t('loading') }</div>
    );
  }
}

export default DeviceList;
